import { makeStyles } from "@material-ui/core"

export const CreateTenantStyles = makeStyles((theme) => ({
    fieldLabel: {
        fontWeight: 'bold'
    },
}));